import React, { useState, useEffect } from 'react';
import './Navbar.css';

export default function Navbar({ navigate, currentPage }) {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const handleNav = (page) => {
    navigate(page);
    setMenuOpen(false);
  };

  return (
    <nav className={`navbar ${scrolled ? 'scrolled' : ''}`}>
      <div className="navbar-inner container">
        <button className="navbar-logo" onClick={() => handleNav('home')}>
          <img src="/bee-logo-pink.png" alt="HiveeClub" className="logo-img" />
        </button>

        <div className={`navbar-links ${menuOpen ? 'open' : ''}`}>
          {[['home','Home'],['about','About'],['faq','FAQ'],['contact','Contact']].map(([page, label]) => (
            <button
              key={page}
              className={`nav-link ${currentPage === page ? 'active' : ''}`}
              onClick={() => handleNav(page)}
            >
              {label}
            </button>
          ))}
        </div>

        <div className="navbar-actions">
          <button className="btn-download" onClick={() => window.open('https://apps.apple.com/au/app/hiveeclub/id1584271794','_blank')}>
            <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
              <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 14.5v-9l6 4.5-6 4.5z"/>
            </svg>
            Download App
          </button>
          <button className={`hamburger ${menuOpen ? 'open' : ''}`} onClick={() => setMenuOpen(!menuOpen)} aria-label="Menu">
            <span/><span/><span/>
          </button>
        </div>
      </div>
    </nav>
  );
}
